import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { SearchTabletPage } from '../pages/search/Tablet/search';
import { SearchPhoneStartPage } from '../pages/search/Phone/SearchPhoneStartPage';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GlobalsSingleton } from './core/GlobalsSingleton';


@Component({
	templateUrl: 'app.html',
	providers: [ GlobalsSingleton ]
})
export class MyApp {

	@ViewChild(Nav) nav: Nav;

	rootPage: any = SearchTabletPage;

	constructor(public globals: GlobalsSingleton, public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, public meta: Meta) {
		console.log("//////////////////////");
		console.log("/// MyApp: globals = " + globals);
		console.log("/// MyApp: globals.isPhone() = " + globals.isPhone());
		console.log("//////////////////////");
	
	
		if (globals.isPhone()) {
			this.rootPage = SearchPhoneStartPage;
		}
		else {
			this.rootPage = SearchTabletPage;
		}
	
	
		this.initializeApp();
		// <meta http-equiv="ScreenOrientation" content="autoRotate:disabled">
		// Bringt anscheinend nix, schadet aber auch nicht.
		let metaDefinition: MetaDefinition = {
			httpEquiv: 'ScreenOrientation',
			content: 'autoRotate:disabled'
		};
		meta.addTag(metaDefinition);
	}

	initializeApp() {
		this.platform.ready().then(() => {
			this.statusBar.styleDefault();
			this.splashScreen.hide();
		});
	}

//	openPage(page) {
//		this.nav.setRoot(page.component);
//	}



	/*	Damit wird erzwungen dass die Seite erst nach dem Instanziieren der Klasse in app.html eingesetzt wird
	 *	Ansonsten, wenn man dort einfach
	 *
	 *		<ion-nav [root]="rootPage" #content swipeBackEnabled="true"></ion-nav>
	 *
	 *	hinschreibt wird dass Attribut "rootpage" genommen BEVOR der Konstruktor aufgerufen wirde
	 *	und dann steht da nix drin.
	 */
	getRootPage() : any {
		return this.rootPage;
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts